import "./DeleteEventDialog.scss";
import { Dialog, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { ADMIN_ROLES, API_RESPONSE, COMMON_CONSTANTS, NUMBER_CONSTANTS, SESSIONS_ERROR_MESSAGE, STORAGE_KEYS, TOASTER_CONFIGS } from "../../../../Utilities/Constants/Constants";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import moment from "moment";
import { GetSessionStorageData } from "../../../../Services/Helpers/Helper";
import ConfirmationDialog from "../../../../Shared/ConfirmationDialog/ConfirmationDialog";

const DeleteEventDialog = (props:any)=>{
     const [ deleteType, setDeleteType ]= useState("");
     const [ roleId, setRoleId ]= useState("");
     const [ reasonText, setReasonText ]= useState("");
     const [ reasonTouched, setReasonTouched ] = useState(API_RESPONSE.FALSE);
     const [ dialogContent, setDialogContent ] = useState(SESSIONS_ERROR_MESSAGE.SESSION_DELETE_ALERT_SINGLE)
     const [modalStatus, setmodalStatus] = useState(API_RESPONSE.FALSE);
    /* Dialog close function */
    const onClose = () => {
        return props.openStatus(false);
    };
     
    useEffect(()=>{
      let roleId:any= GetSessionStorageData(STORAGE_KEYS.ROLE);
      setRoleId(roleId);
    },[props])

    /* Setting type of delete event */
    const setDelType = (event:any)=>{
      setDeleteType(event.target.value);
    }

    /* Delete slot API call */
    const deleteApiCall = (slotData:any,event:any) => {
      let startDate=  moment(props.currentDate).format(COMMON_CONSTANTS.YMD_FORMAT);
      axiosInstance.delete(API_END_POINTS.SESSIONS_LIST +
         "?service_session_id=" + slotData.service_provider_id +
        "&teach_service_id=" + slotData.teach_service_provider_id +
          "&start_date=" + startDate +
          "&event_type=" + deleteType +
          "&end_date=" + event.end_date +
          "&start_time=" + slotData.start_time +
          "&end_time=" + slotData.end_time +
          "&reason=" + reasonText
          )
          .then((response:any)=>{
            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
              toast.success(response.data.message, TOASTER_CONFIGS);
              onClose();
            }
          });
    };


    /* Confirms whether slots booked and delete */
    const onOpenConfirmationDialg = (slotData:any,event:any)=>{
      let startDate=  moment(props.currentDate).format(COMMON_CONSTANTS.YMD_FORMAT);
      axiosInstance.get(API_END_POINTS.BOOKING_VALIDATION +
         "?service_session_id=" + slotData.service_provider_id +
        "&teach_service_id=" + slotData.teach_service_provider_id +
          "&start_date=" + startDate +
          "&event_type=" + deleteType +
          "&end_date=" + event.event_info.end_date +
          "&start_time=" + slotData.start_time +
          "&end_time=" + slotData.end_time +
          "&reason=" + reasonText
          )
          .then((response:any)=>{
            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
              if(response.data.result.is_booked){
                if(deleteType===`${NUMBER_CONSTANTS.ONE}`){
                  setDialogContent(SESSIONS_ERROR_MESSAGE.SESSION_DELETE_ALERT_SINGLE);
                }else{
                  setDialogContent(SESSIONS_ERROR_MESSAGE.SESSION_DELETE_ALERT_MULTIPLE);
                }
                setmodalStatus(API_RESPONSE.TRUE);        
       
              }else{
                delCategoryPayload();
              }
            }
          });
    }

    /* Delete slot payload based on roleId */
    const onDelCategory = () => {
       setReasonTouched(API_RESPONSE.TRUE);
       if(reasonText.trim() !== ''){
           delCategoryPayload();
        /* if(roleId===ADMIN_ROLES.TUTOR){
          onOpenConfirmationDialg(props.payload,props.payload.tutor_session);
        }else if(roleId===ADMIN_ROLES.RECREATIONAL_PERSONAL){
          onOpenConfirmationDialg(props.payload,props.payload.personaltrainer_session);
        }else if(roleId===ADMIN_ROLES.RECREATIONAL_CAMP){
          onOpenConfirmationDialg(props.payload,props.payload.recreationalcamp_session);
        } */

        
       }
      };

      /* Payload for Delete slot API */
      const delCategoryPayload = () => {
          if(roleId===ADMIN_ROLES.TUTOR){
            deleteApiCall(props.payload,props.payload.tutor_session);
          }else if(roleId===ADMIN_ROLES.RECREATIONAL_PERSONAL){
            deleteApiCall(props.payload,props.payload.personaltrainer_session);
          }else if(roleId===ADMIN_ROLES.RECREATIONAL_CAMP){
            deleteApiCall(props.payload,props.payload.recreationalcamp_session);
          }
      }

      /* Handling confirmation dialog close */
      const onCloseDialog = (status: any) => {
        if (status === API_RESPONSE.TRUE) {
          delCategoryPayload();
        }else{
          setmodalStatus(API_RESPONSE.FALSE);     
        }
      }
      
    return(
        <div className="delete-dialog-wrapper">
             <Dialog
        className="delete-dialog"
        open={props.modalState}
        sx={{ "& .MuiDialog-paper": "cus-dialog" }}
      >
         <ConfirmationDialog
          content={dialogContent}
          modalState={modalStatus}
          dialogStatus={onCloseDialog}
        />

        <DialogTitle className="title-wrap">
          <h5 className="title">{"Cancel recurring event"}</h5>
          <div>
          <CloseIcon className="close-icon" onClick={onClose} />
          </div>
        </DialogTitle>

        <DialogContent>
            <div>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                onChange={setDelType}
                >
                {roleId!==ADMIN_ROLES.RECREATIONAL_CAMP && <FormControlLabel value={`${NUMBER_CONSTANTS.ONE}`} control={<Radio />} label="Cancel this event" /> }
                <FormControlLabel value={`${NUMBER_CONSTANTS.TWO}`} control={<Radio />} label="Cancel this event and following events" />
            </RadioGroup>
           {deleteType &&  <div>
              <p className="reason-label">Reason for cancel:</p>
              <textarea 
              rows={3} 
              className="reason-textbox"
              onChange={(e:any)=>{ setReasonText(e.target.value);}}
              onBlur={() => {
                setReasonTouched(API_RESPONSE.TRUE);
              }}
              />
              { reasonTouched && reasonText==='' && <p className="reason-text">{"Please enter the reason"}</p>}
            </div>}
            <div className="dialog-btn-wrapper">
                <button className="btn btn-primary cancel-btn"  onClick={onClose}>Cancel</button>
                <button className="btn btn-success submit-btn" onClick={onDelCategory}>Submit</button>
            </div>
            </div>
            
        </DialogContent>
        </Dialog>
        </div>
    )
};

export default DeleteEventDialog;